export interface TaskTypeOption {
  value: string;
  label: string;
}

export const taskTypeOptionsByModule: Record<string, TaskTypeOption[]> = {
  writing: [
    { value: 'form_filling', label: 'Form filling' },
    { value: 'short_message_email', label: 'Short message / email' },
    {
      value: 'essay_report_article_opinion',
      label: 'Essay / report / article / opinion',
    },
  ],
  speaking: [
    { value: 'introduction', label: 'Introduction' },
    { value: 'presentation_monologue', label: 'Presentation / monologue' },
    {
      value: 'dialogue_roleplay_discussion',
      label: 'Dialogue / roleplay / discussion',
    },
  ],
};

export const moduleRequiresTaskType = (module?: string): boolean =>
  module === 'writing' || module === 'speaking';

export const getTaskTypeOptionsForModule = (module?: string): TaskTypeOption[] =>
  taskTypeOptionsByModule[module || ''] || [];

export const isTaskTypeAllowedForModule = (
  module?: string,
  taskType?: string,
): boolean =>
  Boolean(
    taskType &&
      getTaskTypeOptionsForModule(module).some((option) => option.value === taskType),
  );
